import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const EmailSendsPage = lazy(() => import('@/pages/emails/sends'));

export const Route = createFileRoute('/emails/sends')({
  component: function EmailSendsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <EmailSendsPage />
      </Suspense>
    );
  },
});
